export type ExternalTourProps = {
  createdTimestamp: number | string;
  isEditable: boolean;
  isReadOnly: boolean;
  label: string;
  referenceId: string;
  sourceName: string;
  status: string;
  tourType: string;
  tourUrl: string;
};

const ExternalTour = ({
  createdTimestamp = '',
  isEditable = false,
  isReadOnly = false,
  label = '',
  referenceId = '',
  sourceName = '',
  status = '',
  tourType = '',
  tourUrl = '',
}: Partial<ExternalTourProps> = {}): ExternalTourProps => ({
  createdTimestamp: Number(createdTimestamp),
  isEditable: Boolean(isEditable),
  isReadOnly: Boolean(isReadOnly),
  label: String(label),
  referenceId: String(referenceId),
  sourceName: String(sourceName),
  status: String(status),
  tourType: String(tourType),
  tourUrl: String(tourUrl),
});

export default ExternalTour;
